import React, { useContext, useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from "@material-ui/core";
import { useStores } from "../../../../hooks";
import { observer } from "mobx-react";
import PageStoreContext from "./context";
import  { DeleteTableRequest } from "../../../../services/tables/requestsResponses"
import { PageFormType } from "./store";
import { localize } from "../../../../common/libs";
import { SnackbarType } from "../../../../stores/common";
import { Trans, useTranslation } from "react-i18next";


const DeleteTableForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const { authStore, generalStore } = useStores();
    const pageStore = useContext(PageStoreContext);
    const { currentTable, isFormOpen } = pageStore.forms[PageFormType.deleteTable];

    const [title, setTitle] = useState("");
    const [publicId, setPublicId] = useState(1);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    useEffect(() => {
        if (currentTable) {
            setTitle(localize(currentTable.data.title));
            setPublicId (currentTable.data.publicId);
        }
    }, [currentTable, pageStore]);

    const submitDelete = async (event) => {
        const dataDeleteTable: DeleteTableRequest = {
            id: currentTable.id,
            organizationBranchId: authStore.currentUser.organizationData.organizationBranchId,
        };
        const deletedTable = await pageStore.deleteTable(dataDeleteTable);
        if (!deletedTable) {
            const params: ({type:SnackbarType, title: string, description?: string}) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);

        } else {
            generalStore.showSuccessSnackbar (t("menu:tables.tableRemoved"));
            pageStore.closeForm(PageFormType.deleteTable)
        }
    }


    return (
        <Dialog
            open={isFormOpen}
            onClose={ () => {
                pageStore.closeForm(PageFormType.deleteTable)
            }
        }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:tables.removingTable")}
            </DialogTitle>
            <DialogContent>
                <Trans i18nKey="menu:tables.sureToDeleteTable" values={{title: title, publicId: publicId}}/>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => {
                    pageStore.closeForm(PageFormType.deleteTable)
                    }
                } color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="default"
                    onClick={submitDelete}
                >
                    {t("general:delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteTableForm);


